// extracted by mini-css-extract-plugin
module.exports = {"NavHeader":"Style_NavHeader__1V-Vy","NavHeader__link":"Style_NavHeader__link__1tnuM","active":"Style_active__3It6e"};